import { apiRequest } from './client';
import type {
  CreateWasteInput,
  WasteCaptureItem,
  WasteCaptureOptions,
  WasteReport,
  WasteReversalResult,
  WasteReviewInfo,
  WasteReviewQueue,
  WasteReviewStatus,
  WasteTeamToday,
  WasteThreshold,
  WasteThresholdMode,
} from '../types/waste';

// F1 · Mermas. La seguridad (tienda asignada, categoría, fecha, quién anula) la aplica el backend.
const PATH = '/api/inventory/waste';

export const getWasteOptions = () => apiRequest<WasteCaptureOptions>(`${PATH}/options`);
// Registrar una merma no se queda colgado en «Registrando…»: a los 30 s se corta y la pantalla lo
// trata como resultado DESCONOCIDO (conserva la llave; reintentar no duplica).
const RECORD_TIMEOUT_MS = 30_000;
export const recordWaste = (input: CreateWasteInput) => apiRequest<{ waste: WasteCaptureItem; replayed: boolean }>(PATH, { ...json('POST', input), signal: timeoutSignal(RECORD_TIMEOUT_MS) });
export const getMyWasteToday = () => apiRequest<{ items: WasteCaptureItem[] }>(`${PATH}/mine/today`);
export const getTeamWasteToday = (storeId?: string) => apiRequest<WasteTeamToday>(`${PATH}/today${storeId ? `?storeId=${encodeURIComponent(storeId)}` : ''}`);
export const reverseWaste = (id: string, reason: string) => apiRequest<WasteReversalResult>(`${PATH}/${id}/reverse`, json('POST', { reason }));
export const getWasteThreshold = () => apiRequest<WasteThreshold>(`${PATH}/settings`);
export const setWasteThreshold = (input: { mode: WasteThresholdMode; value: number; uncostedPercentage?: number }) => apiRequest<WasteThreshold>(`${PATH}/settings`, json('PUT', input));
// F2 · «Por revisar», «Ya la revisé» y reporte (OWNER/MANAGER). Las fechas son días de la tienda (AAAA-MM-DD).
export const getWasteReviewQueue = (params: { dateFrom: string; dateTo: string; storeId?: string; status: WasteReviewStatus }) => apiRequest<WasteReviewQueue>(`${PATH}/review${toQuery(params)}`);
export const markWasteReviewed = (id: string, note?: string) => apiRequest<{ status: 'reviewed' | 'already_reviewed'; wasteId: string; review: WasteReviewInfo }>(`${PATH}/${id}/review`, json('POST', note ? { note } : {}));
export const getWasteReport = (params: { dateFrom: string; dateTo: string; storeId?: string }) => apiRequest<WasteReport>(`${PATH}/report${toQuery(params)}`);

function toQuery(params: Record<string, string | undefined>) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => { if (value) query.set(key, value); });
  const text = query.toString();
  return text ? `?${text}` : '';
}

function json(method: string, body: unknown): RequestInit {
  return { method, body: JSON.stringify(body) };
}

function timeoutSignal(ms: number): AbortSignal | undefined {
  if (typeof AbortController === 'undefined') return undefined;
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ms);
  return controller.signal;
}
